"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = exports.formatAccountSpecifics = void 0;
const invariant_1 = __importDefault(require("invariant"));
const bignumber_js_1 = require("bignumber.js");
const preloadedData_1 = require("./preloadedData");
const account_1 = require("../../account");
const currencies_1 = require("../../currencies");
const logic_1 = require("./logic");
function formatOperationSpecifics(op, unit) {
    const { validators } = op.extra;
    return (validators || [])
        .map(v => `\n    to ${v.address} ${unit
        ? (0, currencies_1.formatCurrencyUnit)(unit, new bignumber_js_1.BigNumber(v.amount), {
            showCode: true,
            disableRounding: true,
        }).padEnd(16)
        : v.amount}`)
        .join("");
}
function formatAccountSpecifics(account) {
    var _a, _b, _c, _d;
    const { cosmosResources } = account;
    (0, invariant_1.default)(cosmosResources, "cosmos account expected");
    const { validators } = (_a = (0, preloadedData_1.getCurrentCosmosPreloadData)()[account.currency.id]) !== null && _a !== void 0 ? _a : {
        validators: [],
    };
    const unit = (0, account_1.getAccountUnit)(account);
    const formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true,
    };
    let str = " ";
    str += (0, currencies_1.formatCurrencyUnit)(unit, account.spendableBalance, formatConfig) + " spendable. ";
    if (cosmosResources === null || cosmosResources === void 0 ? void 0 : cosmosResources.delegatedBalance.gt(0)) {
        str +=
            (0, currencies_1.formatCurrencyUnit)(unit, cosmosResources.delegatedBalance, formatConfig) + " delegated. ";
    }
    if (cosmosResources === null || cosmosResources === void 0 ? void 0 : cosmosResources.unbondingBalance.gt(0)) {
        str +=
            (0, currencies_1.formatCurrencyUnit)(unit, cosmosResources.unbondingBalance, formatConfig) + " unbonding. ";
    }
    const mappedDelegations = (0, logic_1.mapDelegations)((_b = cosmosResources === null || cosmosResources === void 0 ? void 0 : cosmosResources.delegations) !== null && _b !== void 0 ? _b : [], validators, unit);
    if (mappedDelegations.length) {
        str += "\nDELEGATIONS\n";
        str += mappedDelegations
            .map(d => `  to ${d.validatorAddress} ${(0, currencies_1.formatCurrencyUnit)(unit, d.amount, {
            showCode: true,
            disableRounding: true,
        })} ${d.pendingRewards.gt(0)
            ? " (claimable " +
                (0, currencies_1.formatCurrencyUnit)(unit, d.amount, {
                    disableRounding: true,
                }) +
                ")"
            : ""}`)
            .join("\n");
    }
    const mappedUnbondings = (0, logic_1.mapUnbondings)((_c = cosmosResources === null || cosmosResources === void 0 ? void 0 : cosmosResources.unbondings) !== null && _c !== void 0 ? _c : [], validators, unit);
    if (mappedUnbondings.length) {
        str += "\nUNDELEGATIONS\n";
        str += mappedUnbondings
            .map(d => `  from ${d.validatorAddress} ${(0, currencies_1.formatCurrencyUnit)(unit, d.amount, {
            showCode: true,
            disableRounding: true,
        })}`)
            .join("\n");
    }
    const mappedRedelegations = (0, logic_1.mapRedelegations)((_d = cosmosResources === null || cosmosResources === void 0 ? void 0 : cosmosResources.redelegations) !== null && _d !== void 0 ? _d : [], validators, unit);
    if (mappedRedelegations.length) {
        str += "\nREDELEGATIONS\n";
        str += mappedRedelegations
            .map(d => `  from ${d.validatorSrcAddress} to ${d.validatorDstAddress} ${(0, currencies_1.formatCurrencyUnit)(unit, d.amount, {
            showCode: true,
            disableRounding: true,
        })}`)
            .join("\n");
    }
    return str;
}
exports.formatAccountSpecifics = formatAccountSpecifics;
function fromOperationExtraRaw(extraRaw) {
    const extra = {};
    if (extraRaw.validator) {
        extra.validator = {
            address: extraRaw.validator.address,
            amount: new bignumber_js_1.BigNumber(extraRaw.validator.amount),
        };
    }
    if (extraRaw.validators && extraRaw.validators.length > 0) {
        extra.validators = extraRaw.validators.map(validator => ({
            address: validator.address,
            amount: new bignumber_js_1.BigNumber(validator.amount),
        }));
    }
    if (extraRaw.sourceValidator) {
        extra.sourceValidator = extraRaw.sourceValidator;
    }
    if (extraRaw.autoClaimedRewards) {
        extra.autoClaimedRewards = extraRaw.autoClaimedRewards;
    }
    if (extraRaw.memo) {
        extra.memo = extraRaw.memo;
    }
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    const extraRaw = {};
    if (extra.validator) {
        extraRaw.validator = {
            address: extra.validator.address,
            amount: extra.validator.amount.toString(),
        };
    }
    if (extra.validators && extra.validators.length > 0) {
        extraRaw.validators = extra.validators.map(validator => ({
            address: validator.address,
            amount: validator.amount.toString(),
        }));
    }
    if (extra.sourceValidator) {
        extraRaw.sourceValidator = extra.sourceValidator;
    }
    if (extra.autoClaimedRewards) {
        extraRaw.autoClaimedRewards = extra.autoClaimedRewards;
    }
    if (extra.memo) {
        extraRaw.memo = extra.memo;
    }
    return extraRaw;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports.default = {
    formatAccountSpecifics,
    formatOperationSpecifics,
    fromOperationExtraRaw,
    toOperationExtraRaw,
};
//# sourceMappingURL=account.js.map